module.exports = "<div class=\"footer\" id=\"footer\">\n  Powered by Vikas Global Solutions Ltd.\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/footer/footer.component.html
// module id = ./src/app/common/footer/footer.component.html
// module chunks = main